<template>
  <div v-if="this.$store.state.user && this.$store.state.user.is_admin">
    <h1>New Comic</h1>
    <p v-if="message">Message: {{message}}</p>
    Last Comic ID:<input
      type="number"
      v-model="lastComicId"
      @change="getSuggestions"
    > Selected: #{{selectedSuggestion}}
    <div v-for="suggestion, index of suggestions" v-bind:class="{
      'suggestion': true,
      'selectedSuggestion': selectedSuggestion === suggestion.pk_post_id
    }">
       <input
        type="radio"
        v-bind:value="suggestion.pk_post_id"
        v-bind:checked="selectedSuggestion === suggestion.pk_post_id"
        @click="selectedSuggestion = $event.target.value"
        name="radio"
      >
      #{{suggestion.pk_post_id}}
      [{{suggestion.votes}} votes]
      {{suggestion.username}}<br>
      {{suggestion.text}}
    </div>

    <hr>
    <form enctype="multipart/form-data" novalidate v-if="!isSaving">
      <div class="dropbox">
        <input
          type="file"
          multiple
          :name="uploadFieldName"
          :disabled="isSaving"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length
          "
          accept="image/*"
          class="input-file"
        >
        <p v-if="isInitial">
          Drag your file(s) here to begin<br> or click to browse
        </p>
        <p v-if="isSaving">
          Uploading {{ fileCount }} files...
        </p>
      </div>
    </form>
    <hr>
    <p v-if="uploadedFiles.length === 0">[Uploaded images will appear here]</p>
    <div v-for="file of uploadedFiles" class="uploaded">
      <p>{{replaceURL(file)}}</p>
      <img :src="file">
    </div>
    <hr>
    <textarea
      class="text u-full-width"
      v-model="content"
      placeholder="Write your draft elsewhere and paste in -- there's no draft functionality here!"
    ></textarea>
    <hr>
    <p v-if="!content">[Preview will appear here]</p>
    <div class="contents" v-html="content.split('./comics').join(api + '/comics')"></div>
    <hr>
    <p>Unlock:</p>
    <input
      type="datetime-local"
      class="u-full-width"
      v-model="unlock"
    >
    <p>Lock:</p>
    <input
      type="datetime-local"
      class="u-full-width"
      v-model="lock"
    >
    <hr>
    <textarea
      class="note u-full-width"
      v-model="note"
      placeholder="Note to the users (optional)"
    ></textarea>
    <hr>
    <button
      class="button"
      @click="createComic"
    >Upload Comic</button>
    <p v-if="message">Message: {{message}}</p>
  </div>
  <div v-else>
    <p>Nope</p>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  name: 'app',
  data () {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      uploadFieldName: 'photos[]',
      content: '',
      unlock: moment().add(1, 'days').format('YYYY-MM-DDT00:00'),
      lock: moment().add(1, 'days').format('YYYY-MM-DDT18:30'),
      lastComicId: 0,
      suggestions: [],
      selectedSuggestion: 0,
      note: '',
      message: ''
    }
  },
  computed: {
    api () {
      return process.env.API_URL
    },
    isInitial () {
      return this.currentStatus === 'initial'
    },
    isSaving () {
      return this.currentStatus === 'saving'
    },
    isSuccess () {
      return this.currentStatus === 'success'
    },
    isFailed () {
      return this.currentStatus === 'error'
    }
  },
  created () {
    this.reset()
    this.getSuggestions(0)
  },
  methods: {
    reset () {
      // reset form to initial state
      this.currentStatus = 'initial'
      this.uploadedFiles = []
      this.uploadError = null
    },
    getSuggestions () {
      this.$store.dispatch('getComic', this.lastComicId).then(this.updateSuggestions)
    },
    updateSuggestions (res) {
      console.log(res)
      if (!this.lastComicId) {
        this.lastComicId = parseInt(res.max_id, 10)
      }
      this.suggestions = res.posts.filter(p => p.type === 'suggestion')
    },
    replaceURL (fileURL) {
      return fileURL.replace(process.env.API_URL + '/comics', './comics')
    },
    upload (formData) {
      const url = `${process.env.API_URL}/admin/uploadcomics.php`
      return this.$http.post(url, formData).then(res => {
        if (res.body.status === 'success') {
          this.currentStatus = 'success'
          this.uploadedFiles = this.uploadedFiles.concat(res.body.data)
        } else {
          this.currentStatus = 'error'
          this.uploadError = res.body.data
        }
      }).catch(err => {
        this.uploadError = err
        this.currentStatus = 'error'
      })
    },
    save (formData) {
      // upload data to the server
      this.currentStatus = 'saving'
      this.upload(formData)
    },
    filesChange (fieldName, fileList) {
      const formData = new FormData()
      if (!fileList.length) return
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          formData.append(fieldName, fileList[x], fileList[x].name)
        })
      // save it
      this.save(formData)
    },
    createComic () {
      this.$http.post(process.env.API_URL + '/admin/createcomic.php', {
        'origin_post_id': this.selectedSuggestion,
        'content': this.content,
        'note': this.note,
        'unlock_time': this.unlock,
        'lock_time': this.lock
      }).then(res => {
        if (res.body.status === 'success') {
          this.message = res.body.data
        } else {
          this.message = res.body.data
        }
      })
    }
  }
}

</script>

<style scoped>
  .uploaded {
    border: 1px solid black;
    padding: 1rem;
  }
  .uploaded img {
    max-width: 100%;
  }
  .text {
    height: 300px;
  }
  .selectedSuggestion {
    background-color: #ddffdd;
  }
</style>



// WEBPACK FOOTER //
// Upload.vue?1a58f9bd